<template>
  <div>
    <section id="guie" class="hero-section">
      <div class="view-content">
        <div class="columns is-desktop align-items-center position-relative">
          <div class="column" style="margin-left: 3%;">
            <div class="hero-content">
              <h1>Factores de riesgo psicosocial</h1>
              <div class="subtitle has-text-weight-bold has-text-white">
                Personas Sanas, Mejores Empresas
              </div>
              <a
                v-on:click="continueToTable"
                class="main-btn border-btn btn-hover"
                >Continuar a los resultados</a
              >
              <a
                :href="urlGuia"
                download="SIETE - GUÍA DE INTERPRETACIÓN FACTORES 2026.pdf"
                class="main-btn border-btn btn-hover"
              >
                <div class="btn-text-icon">
                  Guía
                  <i class="material-icons">cloud_download</i>
                </div>
              </a>
              <a href="#features" class="scroll-bottom">
                <i class="material-icons">arrow_downward</i>
              </a>
            </div>
          </div>
          <div class="column">
            <div class="hero-img">
              <img
                src="@/assets/imgGuiaInterFRP.png"
                width="500"
                height="auto"
                alt="guide"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
    <section id="features" class="feature-section">
      <div class="view-content">
        <div class="is-flex flex-wrap justify-content-center">
          <div class="w-full">
            <div class="single-feature">
              <div class="icon">
                <i class="material-icons">ac_unit</i>
              </div>
              <div class="content">
                <h3>¿Qué son los Factores Psicosociales?</h3>
                <p>
                  Son
                  <strong>características sociales y del entorno</strong> con
                  las que interactúan las personas, que tienen la capacidad de
                  influir en su <strong>salud, bienestar, desempeño</strong> o
                  <strong>desarrollo</strong>. Cuando el posible efecto es
                  negativo se habla de un factor de riesgo psicosocial, cuando
                  es beneficioso se considera un factor protector psicosocial.
                  <br />
                  Los <strong>factores psicosociales laborales</strong> son
                  aquellas condiciones propias de la <strong>tarea</strong>, del
                  <strong>entorno organizacional</strong> y las
                  <strong>relaciones sociales</strong> existentes en el trabajo
                  que tienen, dependiendo de su
                  <strong>intensidad, frecuencia o configuración</strong>, la
                  capacidad mencionada de influir en la salud, bienestar,
                  desempeño o desarrollo.
                </p>
              </div>
            </div>
          </div>
          <div class="w-full">
            <div class="single-feature">
              <div class="icon">
                <i class="material-icons">stars</i>
              </div>
              <div class="content">
                <h3>¿Para qué se realiza este estudio?</h3>
                <p style="text-align: start;">
                  1. Conocer el nivel de presentación de los
                  <strong
                    >factores de riesgo psicosocial (FRP) intralaborales, los
                    extralaborales</strong
                  >, y las <strong>condiciones individuales</strong> en la
                  organización.<br />2. Identificar los efectos de los factores
                  psicosociales. Aunque pueden ser muy diversos, aquí se
                  verifica la presencia de tres de ellos:
                  <strong>engagement</strong>, <strong>estrés</strong> y
                  <strong>burnout</strong>.<br />3. Definir los
                  <strong>grupos prioritarios</strong> para la intervención en
                  la organización.<br />4. Dar respuesta a lo estipulado en las
                  <strong
                    >Resoluciones 2646 de 2008 y 2764 de 2022 del Ministerio del
                    Trabajo</strong
                  >. No obstante, para dar cumplimiento cabal a estas
                  resoluciones se debe
                  <strong
                    >continuar con el proceso de gestión basándose en los
                    hallazgos de este estudio.</strong
                  >
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState } from "vuex";
import archivoPDF from "@/assets/files/guia_interpretacion_frp_2026.pdf";

export default {
  data() {
    return {
      urlGuia: archivoPDF,
    };
  },
  props: {
    proceso: {
      Object,
    },
  },
  computed: {
    ...mapState(["empresa", "idtoken", "isOculto"]),
  },
  methods: {
    continueToTable() {
      this.$emit("selectSection", { d: "yResultado", name: "Resultados" });
    },
    scrollTop() {
      const el = document.getElementById("guie");
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    },
  },
  beforeMount() {
    if (!this.isOculto) {
      this.$store.commit("ocultarSide");
    }
  },
  mounted() {
    this.scrollTop();
  },
};
</script>

<style scoped lang="scss">
#guie {
  margin-top: 10px;
}

.title-card {
  border-radius: 10px !important;
  background-color: #f3f3f3 !important;
}

.hero-section {
  position: relative;
  z-index: 1;
  padding: 100px 0 140px;
  @media (max-width: 640px) {
    padding: 25px 20px 51px !important;
  }
  background-image: url("~@/assets/hero-bg.svg");
  background-position: top center;
  background-repeat: no-repeat;
}

.align-items-center {
  align-items: center !important;
}

.position-relative {
  position: relative !important;
}

.hero-section .hero-content {
  margin-bottom: 100px;
}

.hero-section .hero-content h1 {
  font-size: 60px;
  font-weight: bolder;
  color: #fff;
  @media (max-width: 640px) {
    font-size: 40px !important;
  }
}

.hero-section .hero-content .subtitle {
  margin-bottom: 35px;
  text-align: end;
  margin-right: 20px;
  font-size: 30px;
}

.hero-section .hero-content strong {
  color: #fff;
}

.hero-section .hero-content p {
  margin-bottom: 40px;
  font-size: 18px;
  line-height: 28px;
  color: #fff;
}

.hero-section .hero-content .scroll-bottom {
  position: absolute;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #fff;
  border: 3px solid #9246df;
  color: #9246df;
  left: 15px;
  bottom: 0;
  z-index: 9;
}

.hero-section .hero-content .scroll-bottom i {
  font-weight: 700;
  margin-left: 5px;
  margin-top: 5px;
}

.hero-section .hero-content .scroll-bottom {
  margin-left: 2%;
  margin-bottom: 2%;
}

.hero-section .hero-img {
  margin-left: 10% !important;
  @media only screen and (max-width: 1024px) {
    display: flex;
    justify-content: center;
  }
}

.hero-section .hero-img img {
  border-radius: 2% !important;
}

.hero-section .hero-content .main-btn {
  border-color: #9246df;
  color: #9246df;
}

.main-btn.border-btn {
  border: 2px solid #9246df;
  background: white;
  color: #9246df;
}

.btn-hover {
  position: relative;
  overflow: hidden;
}

.main-btn {
  display: inline-block;
  font-weight: 700;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  padding: 13px 33px;
  font-size: 18px;
  border-radius: 50px;
  color: #fff;
  cursor: pointer;
  z-index: 5;
  -webkit-transition: all 0.4s ease-in-out;
  transition: all 0.4s ease-in-out;
  border: none;
  background: #9246df;
  overflow: hidden;
}

.main-btn:hover {
  border-color: white !important;
  background: #9346df89 !important;
  color: white !important;
}

a:hover {
  text-decoration: none;
}

.btn-text-icon {
  display: flex;
  justify-content: space-between;
  align-content: center;
}
.btn-text-icon i {
  margin-left: 5px;
}

// features

@media only screen and (max-width: 1024px) {
  .flex-wrap {
    flex-wrap: wrap;
  }
}

.justify-content-center {
  justify-content: center !important;
}

@media only screen and (min-width: 1400px) {
  .feature-section .single-feature {
    padding: 30px 40px;
  }
}

.feature-section .single-feature .icon {
  width: 130px;
  height: 130px;
  border-radius: 50%;
  background: #9346df1a;
  color: #9246df;
  margin: auto;
  margin-bottom: 30px;
  font-size: 65px;
  line-height: 1;
}

.feature-section .single-feature .icon i {
  font-size: 65px;
  line-height: 1;
}

.feature-section .single-feature {
  width: 80%;
  margin: auto;
  text-align: center;
  padding: 30px 10px;
}

.feature-section .single-feature .content h3 {
  margin-bottom: 20px;
}

.feature-section .single-feature .content p {
  font-size: 18px;
  line-height: 28px;
}

.w-full {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/frpm/GuiaInterpretacion.vue